"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDevelopmentProjects = void 0;
var Api_1 = require("@/api/remote/Api");
exports.getDevelopmentProjects = function (languageCode, pageNumber, sortOrder, districtId) {
    var ALL_DISTRICTS = 0;
    var SORT_LATEST = 2;
    var path = [
        languageCode,
        'api',
        'new-development',
        'getdevelopments',
        pageNumber || 1,
        sortOrder || SORT_LATEST,
        districtId || ALL_DISTRICTS,
    ].join('/');
    return Api_1.api().get(path);
};
